import axios from 'axios';
import { axiosConfig } from '@/config/axiosConfig.js';

export const submit_ajax_by_case = (client_name, case_id) => {
    return axios.get(`${client_name}/webmap/webmap_json/case_${case_id}`, axiosConfig);
}

export const get_case_by_year_obj_ajax = ({ category, start_time, end_time, group_name }) => {
    const url = `/case/case_management/?category=${category}&start_time=${start_time}&end_time=${end_time}&group_name=${group_name}`;
    return axios.get(url, axiosConfig);
}

export const get_case_warn_list_ajax = (sn) => {
    const param = { sn };
    return axios.post('/case/case_management/list_alert_table/', param, axiosConfig);
}

export const get_case_report_list_ajax = (sn) => {
    const param = { sn };
    return axios.post('/case/case_management/list_report_table/', param, axiosConfig);
}

export const get_case_alert_list_ajax = (sn) => {
    const param = { sn };
    return axios.post('/case/case_management/list_light_table/', param, axiosConfig);
}